import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PrismModule, SubmoduleCard, UserAbilities } from '@prism/prism-shared';
import { map, Observable, filter } from 'rxjs';
import { CoreSelectors } from '../shared/state/core';

@Component({
  selector: 'prism-client-home-screen',
  templateUrl: './home-screen.component.html',
  styleUrls: ['./home-screen.component.scss'],
})
export class HomeScreenComponent implements OnInit {

  public moduleCards$!: Observable<SubmoduleCard[]>


  constructor(
    private store: Store,
  ) { }

  ngOnInit() {


    this.moduleCards$ = this.store.select(CoreSelectors.getCurrentUser).pipe(
      filter((user) => !!user),
      map((user) => {
        const abilities: UserAbilities = user.abilities;
        const cards: SubmoduleCard[] = [];

        if (abilities.common.visible) {
          cards.push({ name: PrismModule.PrismCommon, description: 'stuff that is common in departments', icon: '/assets/icons/factory.svg', path: PrismModule.PrismCommon });
        }
        if (abilities.plastics.visible) {
          cards.push({ name: PrismModule.Plastics, description: 'stuff that is used by the plastics team', icon: '/assets/icons/product.svg', path: PrismModule.Plastics });
        }
        if (abilities.c3.visible) {
          cards.push({ name: PrismModule.C3, description: 'stuff that is used by the c3 team', icon: '/assets/icons/delivery_truck.svg', path: PrismModule.C3 });
        }
        if (abilities.metals.visible) {
          cards.push({ name: PrismModule.Metals, description: 'stuff that is used by the metals team', icon: '/assets/icons/laser.svg', path: PrismModule.Metals });
        }
        if (abilities[PrismModule.InjectionMolding]?.visible) {
          cards.push({ name: 'injection molding', description: 'products, components, and materials used by Injection Molding', icon: '/assets/icons/injection-molding.svg', path: PrismModule.InjectionMolding });
        }
        if (abilities[PrismModule.Printing3d]?.visible && abilities[PrismModule.Printing3d]?.products?.visible) {
          cards.push({ name: '3D printing', description: 'versioned printed parts and assemblies with their files and bills of materials', icon: '/assets/icons/3d.svg', path: PrismModule.Printing3d });
        }
        if (abilities.automation.visible) {
          cards.push({ name: PrismModule.Automation, description: 'stuff that is used by the automation team', icon: '/assets/icons/robot.svg', path: PrismModule.Automation });
        }
        if (abilities.admin.visible) {
          cards.push({ name: PrismModule.Admin, description: 'stuff that is used by the admin team', icon: '/assets/icons/crown.svg', path: PrismModule.Admin });
        }
        return cards;
      })
    )




  }

}
